import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

import { PAGE_ROUTES } from "../../utils/stateTypes";
import { PageBanner } from "./PageParts";

const styles = {
  body: {
    padding: "64px 0 96px 0",
    textAlign: "center",
  },
  text: {
    margin: "0 0 32px 0",
  },
};

const NotFound = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Page not found | PM Skillshouse Foundation</title>
        <meta
          name={"robots"}
          content={"noindex"}
        />
      </Helmet>
      <PageBanner title={"PAGE NOT FOUND"} />
      <div
        className={"container"}
        style={styles.body}
      >
        <p style={styles.text}>
          The page you&apos;re looking for doesn&apos;t exist or has moved.
        </p>
        <Link
          to={PAGE_ROUTES.HOME}
          className={"btn btn-orange"}
        >
          Back to home
        </Link>
      </div>
    </React.Fragment>
  );
};

export default NotFound;
